export const PRODUCTION_ASSET_DOMAIN = 'theknot.com/registry/static';
const UNSPECIFIED_PROMISE_REJECTION_REGEX = new RegExp(
  'UnhandledPromiseRejectionWarning: Unspecified reason',
);
const QA_USER_AGENT = 'QATT';
const BROWSER_EXTENSION_IDENTIFIER = '-extension://';

const filterHoneybadgerNotices = notice => {
  const stackIncludesAssetDomain = notice.stack.includes(
    PRODUCTION_ASSET_DOMAIN,
  );

  if (!stackIncludesAssetDomain) {
    // Ignore errors that do not include the production static asset domain in the stack trace
    return false;
  }

  const stackIncludesBrowserExtensions = notice.stack.includes(
    BROWSER_EXTENSION_IDENTIFIER,
  );

  if (stackIncludesBrowserExtensions) {
    // Ignore errors that include a browser extension in the stack trace
    return false;
  }

  if (UNSPECIFIED_PROMISE_REJECTION_REGEX.test(notice.message)) {
    // Ignore errors with a message that includes "UnhandledPromiseRejectionWarning: Unspecified reason"
    return false;
  }

  if (window.navigator?.userAgent?.includes(QA_USER_AGENT)) {
    // Ignore errors from QA automation tests
    return false;
  }

  return true;
};

export default filterHoneybadgerNotices;
